import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'floor'
})
export class FloorPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value[value.length - 1]) {
        case '1': return `${value}st`;
        case '2': return `${value}nd`;
        case '3': return `${value}rd`;
        default: return `${value}th`;
    }
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/pipes/floor.pipe.ts